import { BCTenantInfoDto } from "@app-models";

export interface AppState {
  customers: BCTenantInfoDto[];

}